export function toggle(value) {
    return !value;
}
